module.exports = __webpack_public_path__ + "img/FleeTan.00d75bec.png";